import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ManifestoIntro from "@/components/ManifestoIntro";
import ManifestoChapter from "@/components/ManifestoChapter";
import BookingSection from "@/components/BookingSection";
import Footer from "@/components/Footer";
import { useContent } from "@/lib/useContent";

export default function Home() {
  const { content } = useContent();
  return (
    <div data-testid="home-page" className="relative">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <ManifestoIntro />
      {content.chapters.map((chapter, i) => (
        <ManifestoChapter key={chapter.id} chapter={chapter} index={i} />
      ))}
      <BookingSection />
      <Footer />
    </div>
  );
}
